import { MdAddCircle, MdExpandLess, MdExpandMore } from 'react-icons/md';
import Button from '../Button/Button';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

interface ListHeaderProps {
  title?: string;
  onTitleClick?: () => void;
  onCollapse?: (isCollapsed: boolean) => void;
  titleButtonAriaLabel?: string;
}

export default function ListHeader({ title, onTitleClick, titleButtonAriaLabel, onCollapse }: ListHeaderProps) {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (onCollapse) onCollapse(isCollapsed);
  }, [isCollapsed]);

  return (
    <div className="flex justify-between pb-5">
      <h2 className="my-0 self-center">{title}</h2>
      <div>
      {onCollapse && (
        <Button
          icon={isCollapsed ? MdExpandMore : MdExpandLess}
          data-testid="table-add-button"
          className="self-center py-0 text-primary table-add-button"
          layout="link"
          onClick={() => setIsCollapsed(!isCollapsed)}
          ariaLabel={formatMessage({ id: (isCollapsed ? 'collapse-button-aria-label-expand' : 'collapse-button-aria-label-collapse') })}
        />
      )}
      {onTitleClick && (
        <Button
          icon={MdAddCircle}
          data-testid="table-add-button"
          className="self-center mr-3 py-0 text-primary table-add-button"
          layout="link"
          onClick={onTitleClick}
          ariaLabel={titleButtonAriaLabel ?? title}
        />
      )}
      </div>
    </div>
  );
}
